import { useCallback, type ErrorInfo } from 'react'

import { useDecodedAccessToken } from '@b-stock/fe-core/bstock-next/components'
import { ddLogger } from '@b-stock/fe-core/bstock-react'

type LogContext = Record<string, string | undefined>

export const useLogError = (context?: LogContext) => {
  const decodedAccessToken = useDecodedAccessToken()
  const accountId = decodedAccessToken?.accountId
  const personId = decodedAccessToken?.personId

  return useCallback(
    (error: unknown, info: ErrorInfo) => {
      const extraContext: Record<string, string> = {}
      if (context) {
        for (const [key, value] of Object.entries(context)) {
          if (value !== undefined) extraContext[key] = value
        }
      }

      const additionalProps: Record<string, string> = {
        ...(accountId && { accountId }),
        ...(personId && { personId }),
        ...extraContext,
      }

      ddLogger.error(
        'Caught error at react error boundary',
        { info, ...additionalProps },
        error instanceof Error
          ? error
          : new Error('Error not an instance of Error', { cause: error })
      )
    },
    [accountId, personId, context]
  )
}
